var _path, _path2, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignInIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "1138 -562 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1152.2756 -555.1314C1151.2721 -555.1314 1150.3689 -554.7299 1149.6663 -554.0275C1148.9639 -553.3249 1148.5625 -552.4217 1148.5625 -551.5186C1148.5625 -549.5114 1150.2686 -547.9056 1152.2756 -547.9056C1153.2793 -547.9056 1154.1825 -548.3071 1154.885 -549.0096C1155.5874 -549.7121 1155.989 -550.6153 1155.989 -551.5186C1156.0892 -553.5257 1154.3832 -555.1314 1152.2756 -555.1314Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1156.1897 -547.8052C1155.989 -548.006 1155.5874 -548.006 1155.2864 -547.8052C1155.2864 -547.8052 1152.2756 -545.497 1149.5659 -547.8052C1149.2649 -548.006 1148.9639 -548.006 1148.6626 -547.8052C1148.5625 -547.7049 1145.9531 -545.2962 1145.8528 -540.5794C1145.8528 -540.3787 1145.9531 -540.178 1146.0535 -540.0777C1146.1538 -539.9774 1146.3545 -539.8769 1146.5552 -539.8769L1157.9961 -539.8769C1158.3975 -539.8769 1158.6986 -540.178 1158.6986 -540.5794C1158.6986 -540.7801 1158.799 -545.196 1156.1897 -547.8052Z",
    fill: "currentColor"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1152.2756,
    cy: -547.5043,
    rx: 12.8459,
    ry: 12.8459,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignInIcon);
export default __webpack_public_path__ + "static/media/SignInIcon.54f4b6cd4e5732607e2385182ac3cd57.svg";
export { ForwardRef as ReactComponent };